// @ts-nocheck
import React, { useCallback } from 'react'
import Spinner from 'sharedComponents/Spinner'
import { useAuth0 } from "@auth0/auth0-react"
import AppRouter from './routes/App.Router'
import queryString from 'query-string'
import type { Site } from './types/sites'
import { RefreshBanner } from './sharedComponents/RefreshBanner'
import {
  captureOriginalLandingUrl,
  capturePostAuth0LandingUrl,
  capturePreAuth0LandingUrl,
} from 'modules/landingUrl'

console.log('[WINDOW INNER WIDTH]', window.innerWidth)
export const App : React.FC<Site> = (props) => {
  const { isLoading, user: profileAuth0, getAccessTokenSilently, loginWithRedirect, loginWithPopup } = useAuth0()

  // TODO: write function to validate domain
  const { search: query, pathname } = window.location
  const isLoginRedirect = query.includes('code=') && query.includes('state=')
  const {code, state, ...restUrlParams} = queryString.parse(query)
  const redirectQuery = sessionStorage.getItem('redirectQuery')
  const initialUrlParams = {
    ...queryString.parse(redirectQuery || ''),
    ...Object.keys(restUrlParams).reduce((acc, cur) => ({
      ...acc,
      [cur.toLowerCase()]: restUrlParams[cur],
    }), {}),
  }
  if (isLoginRedirect) {
    capturePostAuth0LandingUrl(initialUrlParams)
  } else {
    captureOriginalLandingUrl()
  }
  if (sessionStorage.getItem('redirectQuery')) {
    sessionStorage.removeItem('redirectQuery')
  }
  console.log('initialUrlParams', initialUrlParams)

  const loginWithRedirectPrepared = useCallback((options) => {
    capturePreAuth0LandingUrl()
    return loginWithRedirect(options)
  }, [loginWithRedirect])

  const loginWithPopupPrepared = useCallback((options) => {
    capturePreAuth0LandingUrl()
    return loginWithPopup(options)
  }, [loginWithPopup])

  const auth0Config = {
    profileAuth0,
    getAccessTokenSilently,
    loginWithRedirect: loginWithRedirectPrepared,
    loginWithPopup: loginWithPopupPrepared,
  }

  return (
    <>
      <RefreshBanner profileAuth0={profileAuth0}/>
      {isLoading ? <Spinner /> : (
        <AppRouter 
          {...auth0Config} 
          isLoginRedirect={isLoginRedirect} 
          initialUrlParams={initialUrlParams} 
          initialPath={pathname} 
          {...props}
        />
      )}
    </>
  )
}

export default App
